import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { SPACING } from "../../theme/constants";

const faqs = [
  {
    question: "Can I change my plan anytime?",
    answer:
      "Yes, you can upgrade or downgrade your plan at any time. Changes will be reflected in your next billing cycle.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept all major credit cards, PayPal, and wire transfers for enterprise plans.",
  },
  {
    question: "Is there a free trial available?",
    answer:
      "Yes, we offer a 14-day free trial for all plans. No credit card required.",
  },
  {
    question: "What happens if I exceed my storage limit?",
    answer:
      "We'll notify you when you're approaching your limit. You can upgrade your plan or purchase additional storage.",
  },
];

const FAQSection = () => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: SPACING.md }}>
          Frequently Asked Questions
        </Typography>

        {faqs.map((faq, index) => (
          <Accordion
            key={index}
            disableGutters
            elevation={0}
            sx={{
              border: 1,
              borderColor: "divider",
              "&:not(:last-child)": { borderBottom: 0 },
              "&::before": { display: "none" },
              "&:first-of-type": {
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
              },
              "&:last-of-type": {
                borderBottomLeftRadius: 8,
                borderBottomRightRadius: 8,
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              sx={{
                "& .MuiAccordionSummary-content": { my: 1.5 },
              }}
            >
              <Typography variant="subtitle2" fontWeight={600}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 0 }}>
              <Typography variant="body2" color="text.secondary">
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </CardContent>
    </Card>
  );
};

export default FAQSection;
